<template>
  <div>
    <b-form-group :label="messageLabel" label-for="tags-with-dropdown">
      <b-form-tags id="tags-with-dropdown" v-model="value" no-outer-focus class="mb-2">
        <template v-slot="{ tags, disabled, addTag, removeTag }">
          <ul v-if="tags.length > 0" class="list-inline mb-2 tag-list">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                variant="danger"
              >{{ tag }}</b-form-tag>
            </li>
          </ul>
          <button 
            v-if="tags.length"
            class="btn btn-primary btn-clear"
            @click="() => tags.forEach(t=>removeTag(t))">
            {{ messageRemoveData || "Remover todos" }}
          </button>
          <button
            v-if="messageExtra && tags.length"
            class="btn btn-primary btn-extra"
            @click="() => extraFunc()">
            {{ messageExtra }}
          </button>
          <div></div>
          <b-dropdown
            dropright
            size="sm" variant="primary"
            menu-class="dropdownview"
            ref="dropdownview">
            <template #button-content>
              {{ messageButton || "Dados" }}
            </template>
            <b-dropdown-form @submit.stop.prevent="() => {}">
              <b-form-group
                :label="messageLabelSearch || 'Pesquisar dado'"
                label-for="tag-search-input"
                label-cols-md="auto"
                class="mb-0"
                label-size="sm"
                :description="searchDesc"
                :disabled="disabled"
              >
                <b-form-input
                  v-model="search"
                  id="tag-search-input"
                  type="search"
                  size="sm"
                  autocomplete="off"
                 ></b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button
              v-for="option in availableOptions"
              :key="option.id"
              @click.native.capture.stop="onOptionClick({ option, addTag })"
            >
              {{ option.name }}
            </b-dropdown-item-button>
            <b-dropdown-text v-if="availableOptions.length === 0">
              {{ messageMissingData || "Nenhum dado disponível" }}
            </b-dropdown-text>
          </b-dropdown>
        </template>
      </b-form-tags>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    initial: {
      type: Array,
      required: false,
      default: () => [],
    },
    messageButton: String,
    messageLabel: String,
    messageLabelSearch: String,
    messageMissingDataSearch: String,
    messageMissingData: String,
    messageRemoveData: String,
    updateSelection: Function,
    messageExtra: String,
    extraFunc: Function,
  },
  data() {
    return {
      search: "",
      value: [],
    };
  },
  computed: {
    criteria() {
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      const options = this.options.filter(
        (opt) => this.value.indexOf(opt.name) === -1
      );
      if (criteria) {
        return options.filter(
          (opt) => opt.name.toLowerCase().indexOf(criteria) > -1
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.messageMissingDataSearch || "Nenhum dado corresponde a sua pesquisa";
      }
      return "";
    },
  },
  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option.name);
    },
  },
  watch: {
    value(newValue) {
      if(this.updateSelection) {
        this.updateSelection(newValue)
      }
    },
    initial(nv) {
      this.value = nv;
    }
  }
};
</script>

<style>
  .dropdownview {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 200px;
    z-index: 2000;
  }

  .dropdownview.show > li > form {
    min-width: 500px;
  }

  .tag-list {
    max-height: 130px;
    overflow-y: auto;
  }
  
  .btn-clear, .btn-extra {
    padding: .15rem .75rem  !important;
    margin-left: 10px;
  }

  .tag-c {
    background: black !important;
    border: none;
  }
</style>